import { colors } from '@material-ui/core'

import palette from '../palette'

export default {
  root: {
    backgroundColor: 'white',
    boxShadow: '0px 10px 15px #1F21251A;',
    color: '#1F2125',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: colors.grey[50]
    },
    '&$selected': {
      backgroundColor: palette.primary.main,
      color: 'white',
      fontsize: '16px',
      padding: '11px',
      lineHeight: 1.75,
      letterSpacing: '0.02857em',
      textTransform: 'none',
      fontWeight: 200,
      '&:hover': {
        backgroundColor: palette.primary.main
      }
    },
    '&:first-child': {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
      width: '122px'
    },
    '&:last-child': {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
      width: '122px'
    }
  }
}
